import { ReactNode } from 'react';

interface ScrollRevealSectionProps {
  children: ReactNode;
  slideProgress: number;
  framesComplete: boolean;
}

const ScrollRevealSection = ({ 
  children, 
  slideProgress,
  framesComplete,
}: ScrollRevealSectionProps) => {
  // Calculate translateY: 100vh -> 0 based on scroll progress
  const translateY = 100 - (slideProgress * 100);
  
  // Transition is complete when slide progress reaches 1
  const isTransitioned = slideProgress >= 1;

  // Don't render until frames are complete
  if (!framesComplete && slideProgress === 0) {
    return null;
  }

  return (
    <div
      className="bg-background z-20"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transform: isTransitioned ? 'translateY(0)' : `translateY(${translateY}vh)`,
        zIndex: 20,
        overflowY: isTransitioned ? 'auto' : 'hidden',
      }}
    >
      {children}
    </div>
  );
};

export default ScrollRevealSection;
